import nsBrowser from '@netsapiens/netsapiens-js/dist/browser';

/**
 * Builds the URL used to bounce an unauthenticated user to the /auth app.
 *
 * When the video app is opened with a `redirect_uri` query param, that param
 * points to a 3rd-party video application the user should land on once auth
 * passes (see init.js, where redirect_uri is consumed and the iotum creds are
 * appended before redirecting there). Bouncing to /auth without carrying it
 * forward loses the destination, so we preserve it through the auth flow,
 * mirroring the query-param passthrough handled in WTAUTH-113.
 *
 * @param {string} [origin] - origin to build the URL against (defaults to current)
 * @returns {string} the /auth/?r=video URL with redirect_uri preserved
 */
export default function buildAuthRedirectUrl(origin = window.location.origin) {
  const authUrl = new URL('/auth/', origin);
  authUrl.searchParams.set('r', 'video');

  // Forward the 3rd-party redirect_uri so the user is sent there after auth.
  const redirectUri = nsBrowser.getQuery('redirect_uri');
  if (redirectUri) {
    authUrl.searchParams.set('redirect_uri', redirectUri);
  }

  return authUrl.href;
}
